import 'core-js';
import React, { Component } from 'react';
import './resources/stylesheets/verifier.css';
import { Router, Switch, Route } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import history from './history';
import thunkMiddleware from 'redux-thunk';
import frontendReducers from './login/api.reducers';
import api from './login/api.middleware';
import VerifierView from './layouts/VerifierView';
import ConfigurationView from './layouts/ConfigurationView';
import LoginView from './layouts/LoginView';
import ReportsView from './layouts/ReportsView';
import DisplayView from './layouts/DisplayView';
import VerifierSelectionView from './layouts/VerifierSelectionView';
import { MetaData } from './components/MetaData';

let createStoreWithMiddleware = applyMiddleware(thunkMiddleware, api)(
  createStore
);
let store = createStoreWithMiddleware(
  frontendReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

class App extends Component {
  render() {
    const APP_ROUTES = [
      {
        path: '/',
        exact: true,
        component: props => <LoginView {...props} />
      },
      {
        path: '/validator',
        exact: true,
        component: props => <VerifierView {...props} />
      },
      {
        path: '/configuration',
        exact: true,
        component: props => <ConfigurationView {...props} />
      },
      {
        path: '/reports',
        exact: true,
        component: props => <ReportsView {...props} />
      },
      {
        path: '/display',
        exact: true,
        component: props => <DisplayView {...props} />
      },
      {
        path: '/validatorSelection',
        exact: true,
        component: props => <VerifierSelectionView {...props} />
      },
      {
        path: '/**',
        exact: true,
        component: () => <div>Not Found</div>
      }
    ];

    return (
      <MetaData>
        <Provider store={store}>
          <Router history={history} basename="/">
            <Switch>
              {APP_ROUTES.map((route, index) => <Route key={index} {...route} />)}
            </Switch>
          </Router>
        </Provider>
      </MetaData>
    );
  }
}

export default App;
